import { WebPush } from '../index';
import { ClientData, VisitorData } from '../../typings';

class BysideWebPush extends WebPush {
    constructor() {
        super({
            adapter: 'byside',
            baseURL: window.bysideWebcare_webpush_baseurl,
            version: window.bysideWebcare_versionid || 1,
        });
    }

    getClientData = (): ClientData => ({
        id: window.bysideWebcare_webcare_id ?? null,
    });

    getVisitorData = (): VisitorData => ({
        uuid: window.byside_webcare_tuid,
        channel: window.bysideWebcare_channel,
        lang: window.bysideWebcare_lang,
        fid: encodeURIComponent(window.bysideWebcare_fid),
        tuid: window.byside_webcare_tuid,
    });
}

window.Sidetalk = window.Sidetalk || {};
window.Sidetalk.WebPush = window.Sidetalk.WebPush || new BysideWebPush();
